import { useLocation } from "@tanstack/react-router";
import type { FetchError } from "common/types/fetchError";
import type { ReactNode } from "react";
import { useState, useEffect } from "react";
import { SWRConfig } from "swr";
import ErrorPage from "./ErrorPage";

interface FetchErrorBoundaryProps {
  children: ReactNode;
}

export default function FetchErrorBoundary({ children }: FetchErrorBoundaryProps) {
  const { pathname } = useLocation();
  const [error, setError] = useState<FetchError | null>(null);
  useEffect(() => setError(null), [pathname]); // clear error when navigating

  return (
    <SWRConfig value={{ onError: (e) => setError(e) }}>
      {error ? <ErrorPage statusCode={error.status} /> : children}
    </SWRConfig>
  );
}
